<ng-select [(ngModel)]="value" [keyDownFn]="selectOnTab" [items]="filteredQualities" bindLabel="name"
    name="quality-select" [searchable]="false" [clearable]="false">
</ng-select>
